var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "formsContainer", staticClass: "formsContainer" },
    [
      _vm._l(_vm.forms, function(form) {
        return _c(_vm.openedFormComponent(form.openedForm), {
          key: form.id,
          tag: "component",
          style: { zIndex: form.zIndex },
          attrs: {
            id: "object-form",
            "object-layer": form.openedForm,
            "action-type": form.formAction,
            "data-received": form.selectedObjectData,
            wkt: form.wkt,
            "street-view": form.showStreetView,
            "link-object-to-pathway": form.linkObjectToPathway,
            "link-pathway-to-pathway": form.linkPathwayToPathway,
            "pathway-nodes": form.pathwayNodes,
            "technical-point-data": form.technicalPointData,
            "technical-site-data": form.technicalSiteData,
            "cable-data": form.cable,
            lineStringWKT: form.lineStringWKT,
            objectNodes: form.objectNodes,
            "slack-data": form.slackData,
            "previous-pos-x": form.objectFormPosition.x,
            "previous-pos-y": form.objectFormPosition.y,
            closureTechPointData: _vm.closureTechPointData,
            techPointGeom: _vm.techPointGeom,
            nextForm: _vm.nextForm,
            creatingBulkTP: _vm.creatingBulkTp,
            bulkTPCoordinates: _vm.bulkTpCoordinates,
            blockageObject: _vm.blockageObject
          },
          on: {
            close: function($event) {
              return _vm.closeFormWithID(form.id)
            },
            "update-technical-point-data": function($event) {
              return _vm.updateTechnicalPointData(form.id, $event)
            },
            "update-geoserver": _vm.updateGeoserver,
            changeViewModeOfObject: function($event) {
              return _vm.changeViewModeOfObject($event, form)
            },
            "create-technical-local": _vm.createTechnicalLocal,
            "open-next-form": function($event) {
              return _vm.openNextForm($event)
            },
            "clear-next-form": _vm.clearNextForm,
            "delete-measurement-area": function($event) {
              return _vm.$emit("delete-measurement-area")
            },
            "open-sync-dialog": function($event) {
              _vm.syncDialog = true
              _vm.assetReservationToSyncID = $event
            },
            "update-tech-point-data": function($event) {
              return _vm.$emit("update-tech-point-data", $event)
            },
            "update-pathway-data": function($event) {
              return _vm.$emit("update-pathway-data", $event)
            },
            openDetails: function($event) {
              return _vm.$emit("openDetails")
            },
            refresh: function($event) {
              return _vm.refresh(form.id, form.openedForm, form.formAction)
            },
            openClosureToExport: function($event) {
              return _vm.$emit("openClosureToExport")
            }
          },
          nativeOn: {
            click: function($event) {
              return _vm.bringFormToFront(form.id)
            }
          }
        })
      }),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.syncDialog,
          title: _vm.$t("SyncData"),
          content: _vm.$t("SyncDataMessage"),
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: { mainAction: _vm.closeSync, secondaryAction: _vm.confirmSync }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13e8c79c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e8c79c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/MultiObjectForm.vue
// module id = null
// module chunks = 